// "Temples" in a campaign's category list → the temple pages (thank-you, payment failed). The API
// sends the list as a string like '["Urgent,Temples"]' (same rule as CampaignDetailWrapper).
export const isTempleCampaign = (campaign) =>
  String(campaign?.category || "")
    .toLowerCase()
    .split(/[^a-z]+/)
    .some((word) => word === "temples" || word === "temple");
